import { useEffect } from "react";
import { RequestState } from "../../constants/request-state";
import { isRequestNone } from "../../utils";
import { amrCompaniesService } from '../../services/amr-companies.service';
import { useDispatch, useSelector } from "react-redux";
import { debtInvestorsActions } from "../../actions/entities/debtInvestors.action";
import { AppState } from "../../types/state/AppState";
import { Company } from "../../types/amr-pipeline/models/Company";

export function useDebtInvestors() {
    const dispatch = useDispatch();
    const { requestState, items } = useSelector((state: AppState) => state.entities.debtInvestors);

    useEffect(() => {
        if (isRequestNone(requestState)) {
            const doRequest = async () => {
                dispatch(debtInvestorsActions.requestDebtInvestors(RequestState.request));
                try {
                    const debtInvestors: Company[] = await amrCompaniesService.getDebtInvestors();
                    dispatch(debtInvestorsActions.responseDebtInvestors(RequestState.success, debtInvestors));
                } catch (e) {
                    dispatch(debtInvestorsActions.requestDebtInvestors(RequestState.failure));
                }
            };

            doRequest();
        }
    }, [requestState, dispatch]);

    return {
        requestState,
        items,
    }
}
